<template>
  <StudyCalendar class="member-calendar" @load="onLoad"></StudyCalendar>
</template>
<script>
import StudyCalendar from '@/modules/stu/components/StudyCalendar.vue';
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'MemberCalendar',
  components: { StudyCalendar },
  methods: {
    onLoad() {
      triggerLoaded(this);
    },
  },
};
</script>
<style lang="scss" scoped>
.member-calendar {
  background-color: white;
  border-radius: 8px;
}
</style>
